export default "__VITE_ASSET__D35jZ4ld__"